import { useEffect } from "react";
import { gql, useQuery } from "@apollo/client";
import { getUserId, shopid } from "../../utils/url.js";
import EmptyPage from "../emptyPages";
import { useNavigate } from "react-router-dom";
import ProductCard from "../productCard/index.jsx";
import Loading from "../loading";
import { removeFromWishlistController } from "../../../node_modules/shops-query/src/modules/wishlist";

const GET_WISHLIST = gql`
  query Wishlist($filter: WishlistFilterInput) {
    wishlist(filter: $filter) {
      userId
      title
      tax
      shopId
      productId
      prize
      noStock
      minStock
      mastercategory
      id
      hsnCode
      featureImage
      discount
      description
      category
    }
  }
`;

const Wishlist = () => {
  const navigate = useNavigate();
  const userId = getUserId();

  const {
    data,
    loading,
    error,
    refetch,
  } = useQuery(GET_WISHLIST, {
    variables: {
      filter: {
        userId: Number(userId),
        shopId: Number(shopid),
      },
    },
    fetchPolicy: "network-only", // Force fetch from server
    skip: !userId,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const wishList = data?.wishlist || [];

  const removeFromWishListHandler = async (productId) => {
    try {
      const response = await removeFromWishlistController({
        userId,
        productId,
        shopId: shopid,
        delete: true,
      });
      await refetch();
    } catch (error) {
      console.warn("Error caught during removal:", error);
      await refetch();
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[50vh] font-poppins">
        <Loading />{" "}
      </div>
    );
  }

  return (
    <div className="font-poppins px-4 sm:px-6 md:px-16">
      {/* Header */}
      <p className="mt-4 md:mt-6 font-semibold text-[18px] sm:text-[20px] md:text-[24px] uppercase">
        Wishlist{" "}
        <span className="font-normal text-[14px] sm:text-[16px]">
          ({wishList.length} products)
        </span>
      </p>

      {/* Empty Wishlist */}
      {wishList.length === 0 ? (
        <EmptyPage
          message="No favourites yet."
          subMessage="Tap the ♡ to save pieces you love."
          buttonText="Browse New Arrivals"
          onButtonClick={() => navigate("/")}
        />
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 mt-6 mb-20 ">
          {wishList.map((item, index) => (
            <ProductCard
              key={item?.productId || index}
              item={item}
              id={item?.productId}
              onRemove={() => removeFromWishListHandler(item.productId)}
              isThisWishlistPage={true}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Wishlist;
